<template>
<div id="layout">
  <navbar>
    <template slot="header">
      <a class="navbar-brand" v-link="{name: 'index'}">cip</a>
    </template>
    <template slot="collapse">
      <h4 v-if="shop" class="navbar-text"><span class="label label-default">{{ shop.name }}</span></h4>
      <form v-if="date" class="navbar-form navbar-left" role="search">
        <date-selector :date.sync="date"></date-selector>
      </form>

      <slot name="header"></slot>

      <ul class="nav navbar-nav navbar-right">
        <li v-if="shop">
          <customer-create-modal
            v-ref:customer-create-modal
            :shop="shop"
          >

          </customer-create-modal>
        </li>
        <li v-if="shop">
          <a v-link="{name: 'informations'}">お知らせ
            <span class="badge">{{ infoCount }}</span>
          </a>
        </li>
        <slot name="alert"></slot>
        <li v-if="account" class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button"
             aria-haspopup="true" aria-expanded="false">
            <span class="glyphicon glyphicon-option-vertical" aria-hidden="true"></span>
          </a>
          <ul class="dropdown-menu">
            <li><a @click="goAdminSite('/customer')">顧客管理</a></li>
            <li><a @click="goAdminSite('/reservation_today')">本日の次回予約</a></li>
            <li><a :href="shiftLink" target="blank">シフト表</a></li>
            <li><a :href="shiftPlanLink" target="blank">シフト希望入力</a></li>
            <li v-if="account.isStaff"><a href="/admin/">管理</a></li>
            <li><a v-link="{name: 'password'}">パスワード変更</a></li>
            <li role="separator" class="divider"></li>
            <li><a href="/account/logout/">ログアウト</a></li>
          </ul>
        </li>
      </ul>
    </template>
  </navbar>
  <div class="container-fluid">
    <slot></slot>
  </div>
</div>
</template>


<script>
import moment from 'moment'
import request from 'superagent'
import { getAccount } from 'getters'

export default {
  name: 'layout',
  props: {
    shop: {
      type: Object,
      default: null,
    },
    date: {
      type: String,
      twoWay: true,
      default: null,
    },
    infoCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    shiftLink () {
      let tmp = moment()
      const year = tmp.year()
      const month = tmp.month() + 1
      return `https://front.kichitto.net/shift/${year}/${month}/`
    },
    shiftPlanLink () {
      let tmp = moment().add(1, 'months')
      const year = tmp.year()
      const month = tmp.month() + 1
      return `https://front.kichitto.net/shift-plan/${year}/${month}/`
    },
  },
  ready () {
    if (this.shop) {
      document.title = `cip ${this.shop.name}`
    } else {
      document.title = 'cip'
    }
  },
  methods: {
    openCustomerCreateModal(event) {
      this.$refs.customerCreateModal.show()
    },
    goAdminSite(path) {
      request
        .get('/api/2/account/obtain_token/')
        .withCredentials()
        .then(res => {
          open(`https://staff.kichitto.net/#/auth?token=${res.body.token}&next=${path}`)
        })
    },
  },
  components: {
    navbar: require('ui/navbar.vue'),
    dateSelector: require('date-selector.vue'),
    customerCreateModal: require('customer/modal-form/index.vue'),
  },
  vuex: {
    getters: {
      account: getAccount,
    },
  },
}
</script>



// WEBPACK FOOTER //
// layout.vue?18f858c0